export const parseAntennaId = (id: string): { base: string; n: number } | null => {
  const m = id.match(/^(.*)_([0-9]+)$/);
  if (!m) return null;
  return { base: m[1], n: parseInt(m[2], 10) };
};

export interface DeviceInterfaceStrategy {
  getTargetsForUpdate(id: string): string[];
}

export const makeImpinjxSpanStrategy = (
  evenSet: number[] = [2, 4, 6, 8, 10, 12],
  oddSet: number[] = [3, 5, 7, 9, 11, 13]
): DeviceInterfaceStrategy => ({
  getTargetsForUpdate(id: string) {
    const p = parseAntennaId(id);
    if (!p) return [id];
    const { base, n } = p;
    if (n === 1) return [`${base}_1`];
    const set = n % 2 === 0 ? evenSet : oddSet;
    return set.map(num => `${base}_${num}`);
  },
});
